export default {
      id: "unit_type_container-usage",
      viewBox: "0 0 36 18",
      url: __webpack_public_path__ + "img/icons.svg#unit_type_container",
      toString: function () {
        return this.url;
      }
    }